import { Component, ElementRef, Inject, Input, OnDestroy, OnInit, ViewChild, } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BillingSummaryData, FinanceService } from 'src/shared/service-proxies/service-proxies';
import { PageHelperService } from '../helpers/page-helper.service';
import { PagebaseComponent } from '../pagebase/pagebase.component';
import { ApplicationStatusService } from '../services/application-status.service';
import { SessionStorageService } from '../services/session-storage.service';
import { Router } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { LocalStorageService } from '../services/local-storage.service';
import { CustomerSettings } from '../services/customer-settings-service';
import { Observable, of } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import * as L from 'leaflet';
import * as R from 'leaflet-responsive-popup';
import { forEach } from '@angular-devkit/schematics';
import { AuthService } from '../security/auth.service';

export class DropDownListItem {
  constructor(id?: string, name?: string) {
    this.id = id,
    this.name = name;
  }

  id: string;
  name: string;
}

@Component({
    selector: 'app-billing-summary-component',
    templateUrl: './billing-summary.component.html',
    styleUrls: ['./billing-summary.component.scss'],
    standalone: false
})
export class BillingSummaryComponent extends PagebaseComponent implements OnDestroy, OnInit {
  // Private variables
  data: BillingSummaryData;
  searchControl: UntypedFormControl = new UntypedFormControl();
  private apiCall;

  // Public variables
  loading: boolean = true;
  
  // Constuctor
  constructor(
    private _financeService: FinanceService,
    private sessionStorageService: SessionStorageService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private customerSettings: CustomerSettings,
    private authService: AuthService,
    pageHelperService: PageHelperService,
    applicationStatusService: ApplicationStatusService
    ) {
    super(pageHelperService, applicationStatusService, customerSettings, "Billing Summary");
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
  }

  unsubscribe() { 
    if (this.apiCall) {
      this.apiCall.unsubscribe();
    }
  }

  reset() {
    this.data = null;
    if (this.apiCall) {
      this.apiCall.unsubscribe();
    }
  }

  // Get the view data
  getData() {
    this.data = null;

    console.log("loading data");
    this.loading = true;
    this.setIsLoading(this.loading);

    this.apiCall = this._financeService
      .getBillingSummary()
      .subscribe(data => {
        this.data = data;    
        this.loading = false;
        this.setIsLoading(this.loading);
      }, error => {
        debugger;
      });
  }

  exportData() {
    this.loading = true;
    this.setIsLoading(this.loading);
    this.apiCall = this._financeService
      .exportBillingSummary()
      .subscribe(data => {
        this.loading = false;
        this.setIsLoading(this.loading);
        let filename = data.fileName;
        let blob: Blob = data.data;
        let a = document.createElement('a');
        a.download = filename;
        a.href = window.URL.createObjectURL(blob);
        a.click();
      }, error => {
        debugger;
      });
  }
}